import { createAsyncThunk } from "@reduxjs/toolkit";
import { API_URL } from "../../../app/config";
import { axiosApiInstance } from "../../../app/axios";
import { ErrorToast, SuccessToast } from "../../../components/toast/Toasts";
import { IWeddingVenue } from "../weddingVenueModel";

export const getAllWeddingVenues = createAsyncThunk(
  "WeddingVenues/FindAllWeddingVenues",
  async () => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/WeddingVenues/FindAllWeddingVenues`,
        {},
      );
      return response.data?.Data;
    } catch (error: any) {
      // ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error Fetching Wedding Venues:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const createWeddingVenue = createAsyncThunk(
  "WeddingVenues/InsertWeddingVenues",
  async (WeddingVenueData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/WeddingVenues/InsertWeddingVenues`,
        WeddingVenueData,
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error creating Wedding Venue:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const updateWeddingVenue = createAsyncThunk(
  "WeddingVenues/UpdateWeddingVenues",
  async (WeddingVenueData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/WeddingVenues/UpdateWeddingVenues`,
        WeddingVenueData,
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error updating Wedding Venue:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const deleteWeddingVenue = createAsyncThunk(
  "WeddingVenues/DeleteWeddingVenues",
  async (ID: number) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/WeddingVenues/DeleteWeddingVenues`,
        { ID },
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error deleting Wedding Venue :", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const getWeddingVenueByID = createAsyncThunk(
  "WeddingVenues/FindByIDWeddingVenues",
  async (ID: number) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/WeddingVenues/FindByIDWeddingVenues`,
        { ID },
      );
      const result = response.data?.Data as any;
      return {
        ID: result.ID,
        Title: result?.Title,
        URL: result?.URL,
        Tagline: result?.Tagline,
        Capacity: result?.Capacity,
        ShortDescription: result?.ShortDescription || "",
        LongDescription: result?.LongDescription || "",
        PackageHighlights: result?.PackageHighlights || "",
        Inclusion: result?.Inclusion || "",
        Exclusion: result?.Exclusion || "",
        MetaTitle: result?.MetaTitle,
        MetaDescription: result?.MetaDescription,
        MetaKeywords: result?.MetaKeywords,
        MainImage: result?.MainImage,
        BannerImage: result?.BannerImage,
        ImageGallery: result?.ImageGallery,
        WeddingInnerimage: result?.WeddingInnerimage || [],
        IsActive: result.IsActive ? 1 : 2,
      } as IWeddingVenue;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error fetching Wedding Venue :", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const getAllActiveWeddingVenues = createAsyncThunk(
  "WeddingVenues/FindAllActiveWeddingVenues",
  async () => {
    try {
      const response = await axiosApiInstance.get(
        `${API_URL}/WeddingVenues/FindAllActiveWeddingVenues`,
      );
      return response.data?.Data;
    } catch (error: any) {
      // ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error Fetching Wedding Venues:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const ActiveInactiveWeddingVenue = createAsyncThunk(
  "WeddingVenues/ActiveInActiveWeddingVenues",
  async (formData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/WeddingVenues/ActiveInActiveWeddingVenues`,
        formData,
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error active-inactive Wedding Venue :", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

// IMAGE UPLOAD
export const WeddingVenueDetailsImageUpload = createAsyncThunk(
  "WeddingVenues/WeddingVenuesImageUpdate",
  async (formData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/WeddingVenues/WeddingVenuesImageUpdate`,
        formData,
        {
          headers: { "content-type": "multipart/form-data" },
        },
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error upload Wedding Venue Image :", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const deleteWeddingVenueImage = createAsyncThunk(
  "WeddingVenues/DeleteWeddingGalleryImage",
  async (ID: number) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/WeddingVenues/DeleteWeddingGalleryImage`,
        { ID: ID },
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error deleting Wedding Venue image:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);
